import { z } from "zod";
import { supabase } from "../supabase/client";
import { loadStarBalance } from "../economy/starWallet";

const snapshotSchema = z.object({ stars: z.number().int().nonnegative(), completedTaskIds: z.array(z.string()) });
export type ProgressSnapshot = z.infer<typeof snapshotSchema>;
export interface ProgressRepository { load(childId: string): Promise<ProgressSnapshot> }

class LocalProgressRepository implements ProgressRepository {
  async load(_childId: string): Promise<ProgressSnapshot> {
    try {
      const history = JSON.parse(localStorage.getItem("lusky:task-history") ?? "[]") as Array<{ id?: string; status?: string }>;
      return snapshotSchema.parse({ stars: Number(localStorage.getItem("lusky:star-total") ?? 12), completedTaskIds: history.filter((item) => item.status === "completed").map((item) => String(item.id)) });
    } catch { return { stars: 12, completedTaskIds: [] }; }
  }
}

class SupabaseProgressRepository implements ProgressRepository {
  async load(childId: string): Promise<ProgressSnapshot> {
    if (!supabase) return new LocalProgressRepository().load(childId);
    const [{ data: attempts, error: attemptsError }, { data: rewards, error: rewardsError }] = await Promise.all([
      supabase.from("task_attempts").select("task_id").eq("child_id", childId).eq("status", "completed"),
      supabase.from("star_reward_ledger").select("stars").eq("child_id", childId)
    ]);
    if (attemptsError || rewardsError) throw attemptsError ?? rewardsError;
    const grossStars = (rewards ?? []).reduce((sum, row) => sum + Number(row.stars ?? 0), 0);
    const stars = await loadStarBalance(childId, grossStars);
    return snapshotSchema.parse({ stars, completedTaskIds: [...new Set((attempts ?? []).map((row) => String(row.task_id)))] });
  }
}

export const progressRepository: ProgressRepository = supabase ? new SupabaseProgressRepository() : new LocalProgressRepository();
